var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('div',{staticStyle:{"margin-top":"62px"}},[_c('v-img',{attrs:{"src":_vm.images,"max-height":"800","contain":""}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }